import { BasketMinusOutlineIcon } from './BasketMinusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8F4899A8-07F0-4C00-90EE-1509BE7A0D4C
 * name basket-minus-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-minus-outline.svg
 * tags
 * - Shopping 
 */
export const ShoppingBasketMinusOutlineIcon = BasketMinusOutlineIcon;
export default ShoppingBasketMinusOutlineIcon